var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import RadioCheckboxCard from '@marketing/components/funnel/FormFields/RadioCheckboxCard';
import { useState } from 'react';
import { useProfileContext } from '../ProfileContext';
import { PURCHASING_MOTIVATION, PURCHASING_MOTIVATIONS } from '../enums';
var PetPurchasingMotivationsInput = function (_a) {
    var handlePurchasingMotivationsChange = _a.handlePurchasingMotivationsChange, petName = _a.petName, purchasingMotivations = _a.purchasingMotivations;
    var _b = useState(purchasingMotivations), selections = _b[0], setSelections = _b[1];
    var handleSelectionChange = function (e) {
        var newSelections = __spreadArray([], selections, true);
        var position = newSelections.indexOf(e.target.value);
        if (e.target.value === PURCHASING_MOTIVATION.NO_ISSUES && e.target.checked) {
            newSelections = [PURCHASING_MOTIVATION.NO_ISSUES];
        }
        else {
            newSelections = newSelections.filter(function (motivation) { return motivation !== PURCHASING_MOTIVATION.NO_ISSUES; });
            if (e.target.checked && position === -1) {
                newSelections.push(e.target.value);
            }
            else if (!e.target.checked && position !== -1) {
                newSelections.splice(position, 1);
            }
        }
        setSelections(newSelections);
        handlePurchasingMotivationsChange(newSelections);
    };
    var serverLoading = useProfileContext().serverLoading;
    return (_jsx("fieldset", __assign({ className: "group", disabled: serverLoading }, { children: _jsxs("div", __assign({ className: "w-full md:min-w-sm grid grid-cols-1 gap-6 md:gap-20" }, { children: [_jsxs("legend", __assign({ className: "text-center" }, { children: ["Does ", petName, " have any dietary concerns?"] })), _jsx("div", __assign({ className: "w-[236px] md:w-[328px] mx-auto grid grid-cols-1 gap-4" }, { children: Object.keys(PURCHASING_MOTIVATIONS).map(function (pm) {
                        var optionId = "purchasing-motivation-".concat(pm);
                        var isChecked = purchasingMotivations.includes(pm);
                        return (_jsx(RadioCheckboxCard, __assign({ className: "px-4 py-5", checked: isChecked, name: "purchasing-motivations", onInputChange: handleSelectionChange, optionId: optionId, type: "checkbox", value: pm }, { children: _jsx("span", __assign({ className: "capitalize text-xs-head-m md:text-xs-head-d font-display" }, { children: PURCHASING_MOTIVATIONS[pm].label })) }), optionId));
                    }) }))] })) })));
};
export default PetPurchasingMotivationsInput;
